import { createContext, useContext, useEffect, useState } from "react";

const translations = {
  pt: {
    nav: {
      services: "Serviços",
      security: "Segurança",
      booking: "Agendar Reunião",
      admin: "Área Administrativa",
      whatsapp: "WhatsApp",
    },
    hero: {
      badge: "AGENDA ABERTA — 2026",
      title1: "Engenharia de Software de Elite para a",
      title2: "Nova Era Digital",
      sub: "Desenvolvimento sob medida, consultoria estratégica em TI, gestão empresarial e suporte técnico contínuo — com blindagem digital de ponta a ponta.",
      ctaSchedule: "Agendar Reunião Online",
      ctaWhatsapp: "Falar no WhatsApp",
      meetingNote: "Sessões via Google Meet / Microsoft Teams",
      stats: [
        { value: "+120", label: "Projetos Entregues" },
        { value: "99.9%", label: "SLA de Uptime" },
        { value: "24/7", label: "Suporte Ativo" },
      ],
    },
    ticker: [
      "CLOUD NATIVE",
      "REACT & PYTHON",
      "ZERO TRUST SECURITY",
      "LGPD COMPLIANCE",
      "DEVOPS & CI/CD",
      "ALTA DISPONIBILIDADE",
      "MICROSSERVIÇOS",
      "GOVERNANÇA DE DADOS",
    ],
    services: {
      eyebrow: "NOSSAS FRENTEES DE ATUAÇÃO",
      title: "Arquitetura de Soluções",
      sub: "Do código-fonte à infraestrutura: expertise especializada para transformar a sua operação.",
      cta: "Agendar este serviço",
      cards: [
        {
          id: "software",
          title: "Desenvolvimento de Software",
          desc: "Aplicações web e mobile, microsserviços e sistemas em nuvem de alta disponibilidade, desenvolvidos sob medida para o seu modelo de negócio.",
          points: ["Apps web & mobile", "APIs e integrações", "Cloud & escalabilidade"],
        },
        {
          id: "consulting",
          title: "Consultoria em TI",
          desc: "Diagnóstico de infraestrutura, auditoria de segurança, migração para cloud e planejamento estratégico de tecnologia.",
          points: ["Auditoria técnica", "Migração cloud", "Roadmap estratégico"],
        },
        {
          id: "management",
          title: "Gestão Empresarial",
          desc: "Automação de processos, implantação de ERP/CRM, dashboards executivos e governança corporativa de dados.",
          points: ["ERP & CRM", "Automação de processos", "BI & dashboards"],
        },
        {
          id: "support",
          title: "Suporte Técnico Especializado",
          desc: "Monitoramento proativo de servidores, Help Desk N1/N2/N3, resposta a incidentes e SLA garantido em contrato.",
          points: ["Monitoramento 24/7", "Help Desk N1–N3", "SLA contratual"],
        },
      ],
    },
    security: {
      eyebrow: "COMPROMISSO NEW ERA",
      title: "Segurança como Fundação",
      sub: "Cada entrega nasce blindada. Confidencialidade, conformidade e continuidade não são opcionais.",
      items: [
        { title: "Acordo de Confidencialidade", desc: "NDA assinado antes de qualquer acesso ao seu ambiente ou dados." },
        { title: "Criptografia Ponta a Ponta", desc: "Dados protegidos em trânsito e em repouso com padrões de mercado." },
        { title: "Conformidade LGPD/GDPR", desc: "Processos e sistemas alinhados às legislações de proteção de dados." },
        { title: "SLA 99.9% de Uptime", desc: "Disponibilidade garantida em contrato com monitoramento contínuo." },
      ],
    },
    booking: {
      eyebrow: "PRIMEIRO PASSO",
      title: "Agende uma Reunião Estratégica Online",
      sub: "Escolha o serviço, a data e o horário. Nossa liderança técnica conduzirá a sessão via Google Meet ou Teams.",
      service: "Serviço de Interesse",
      servicePlaceholder: "Selecione o serviço",
      date: "Data Preferencial",
      time: "Horário Disponível",
      timePlaceholder: "Selecione o horário",
      name: "Nome Completo",
      email: "E-mail Corporativo",
      phone: "Telefone / WhatsApp",
      notes: "Resumo do Projeto ou Desafio (opcional)",
      submit: "Confirmar Agendamento",
      submitting: "Enviando...",
      successTitle: "Solicitação Confirmada!",
      successMsg: "Recebemos o seu agendamento. Nossa equipe confirmará os detalhes e o link da reunião por e-mail e WhatsApp.",
      errorRequired: "Preencha todos os campos obrigatórios.",
      errorGeneric: "Não foi possível enviar. Tente novamente ou chame no WhatsApp.",
      whatsappCta: "Prefere agilidade? Chame direto no WhatsApp",
      responseTime: "Resposta média em até 2h úteis",
      newBooking: "Fazer novo agendamento",
    },
    footer: {
      tagline: "Soluções em tecnologia digital e segurança para empresas que não param.",
      servicesTitle: "Serviços",
      contactTitle: "Contato",
      status: "Todos os sistemas operacionais",
      rights: "Todos os direitos reservados.",
    },
    admin: {
      loginTitle: "Área do Administrador",
      loginSub: "Acesso restrito à gestão de agendamentos.",
      email: "E-mail",
      password: "Senha",
      login: "Entrar",
      loggingIn: "Entrando...",
      loginError: "Credenciais inválidas. Tente novamente.",
      dashboard: "Painel de Agendamentos",
      total: "Total",
      pending: "Pendente",
      confirmed: "Confirmado",
      completed: "Concluído",
      cancelled: "Cancelado",
      all: "Todos",
      filterService: "Filtrar por serviço",
      allServices: "Todos os serviços",
      client: "Cliente",
      serviceCol: "Serviço",
      dateCol: "Data / Hora",
      contactCol: "Contato",
      statusCol: "Status",
      actionsCol: "Ações",
      empty: "Nenhum agendamento encontrado.",
      logout: "Sair",
      back: "Voltar ao site",
      deleted: "Agendamento removido.",
      updated: "Status atualizado.",
      loadError: "Erro ao carregar agendamentos.",
      notesCol: "Observações",
    },
  },
  en: {
    nav: {
      services: "Services",
      security: "Security",
      booking: "Schedule Meeting",
      admin: "Admin Portal",
      whatsapp: "WhatsApp",
    },
    hero: {
      badge: "CALENDAR OPEN — 2026",
      title1: "High-Performance Software Engineering for the",
      title2: "New Digital Era",
      sub: "Custom development, strategic IT consulting, enterprise management and continuous technical support — with end-to-end digital shielding.",
      ctaSchedule: "Schedule Online Meeting",
      ctaWhatsapp: "Chat on WhatsApp",
      meetingNote: "Sessions via Google Meet / Microsoft Teams",
      stats: [
        { value: "+120", label: "Projects Delivered" },
        { value: "99.9%", label: "Uptime SLA" },
        { value: "24/7", label: "Active Support" },
      ],
    },
    ticker: [
      "CLOUD NATIVE",
      "REACT & PYTHON",
      "ZERO TRUST SECURITY",
      "GDPR COMPLIANCE",
      "DEVOPS & CI/CD",
      "HIGH AVAILABILITY",
      "MICROSERVICES",
      "DATA GOVERNANCE",
    ],
    services: {
      eyebrow: "OUR PRACTICE AREAS",
      title: "Solution Architecture",
      sub: "From source code to infrastructure: tailored expertise to transform your operation.",
      cta: "Book this service",
      cards: [
        {
          id: "software",
          title: "Custom Software Development",
          desc: "Web and mobile applications, microservices and high-availability cloud systems built strictly to your business model.",
          points: ["Web & mobile apps", "APIs & integrations", "Cloud & scalability"],
        },
        {
          id: "consulting",
          title: "IT Consulting",
          desc: "Infrastructure diagnostics, security auditing, cloud migration and strategic technology planning.",
          points: ["Technical audit", "Cloud migration", "Strategic roadmap"],
        },
        {
          id: "management",
          title: "Enterprise Management",
          desc: "Process automation, ERP/CRM implementation, executive dashboards and corporate data governance.",
          points: ["ERP & CRM", "Process automation", "BI & dashboards"],
        },
        {
          id: "support",
          title: "Dedicated Technical Support",
          desc: "Proactive server monitoring, Tier 1–3 Help Desk, incident response and contractual SLA.",
          points: ["24/7 monitoring", "Tier 1–3 Help Desk", "Contractual SLA"],
        },
      ],
    },
    security: {
      eyebrow: "THE NEW ERA COMMITMENT",
      title: "Security as Foundation",
      sub: "Every delivery is born shielded. Confidentiality, compliance and continuity are non-negotiable.",
      items: [
        { title: "Non-Disclosure Agreement", desc: "NDA signed before any access to your environment or data." },
        { title: "End-to-End Encryption", desc: "Data protected in transit and at rest with market standards." },
        { title: "LGPD/GDPR Compliance", desc: "Processes and systems aligned with data protection regulations." },
        { title: "99.9% Uptime SLA", desc: "Contract-guaranteed availability with continuous monitoring." },
      ],
    },
    booking: {
      eyebrow: "FIRST STEP",
      title: "Book an Online Strategy Session",
      sub: "Choose the service, date and time. Our technical leadership will lead the call via Google Meet or Teams.",
      service: "Service of Interest",
      servicePlaceholder: "Select a service",
      date: "Preferred Date",
      time: "Available Time Slot",
      timePlaceholder: "Select a time",
      name: "Full Name",
      email: "Business Email",
      phone: "Phone / WhatsApp",
      notes: "Project or Challenge Summary (optional)",
      submit: "Confirm Booking",
      submitting: "Sending...",
      successTitle: "Booking Confirmed!",
      successMsg: "We received your booking. Our team will confirm the details and meeting link by email and WhatsApp.",
      errorRequired: "Please fill in all required fields.",
      errorGeneric: "Could not submit. Try again or reach us on WhatsApp.",
      whatsappCta: "Prefer speed? Message us directly on WhatsApp",
      responseTime: "Average response within 2 business hours",
      newBooking: "Make another booking",
    },
    footer: {
      tagline: "Digital technology and security solutions for companies that never stop.",
      servicesTitle: "Services",
      contactTitle: "Contact",
      status: "All systems operational",
      rights: "All rights reserved.",
    },
    admin: {
      loginTitle: "Admin Portal",
      loginSub: "Restricted access to booking management.",
      email: "Email",
      password: "Password",
      login: "Sign In",
      loggingIn: "Signing in...",
      loginError: "Invalid credentials. Please try again.",
      dashboard: "Bookings Dashboard",
      total: "Total",
      pending: "Pending",
      confirmed: "Confirmed",
      completed: "Completed",
      cancelled: "Cancelled",
      all: "All",
      filterService: "Filter by service",
      allServices: "All services",
      client: "Client",
      serviceCol: "Service",
      dateCol: "Date / Time",
      contactCol: "Contact",
      statusCol: "Status",
      actionsCol: "Actions",
      empty: "No bookings found.",
      logout: "Sign Out",
      back: "Back to site",
      deleted: "Booking removed.",
      updated: "Status updated.",
      loadError: "Failed to load bookings.",
      notesCol: "Notes",
    },
  },
};

const LanguageContext = createContext(null);

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("ne_lang") || "pt");

  useEffect(() => {
    localStorage.setItem("ne_lang", lang);
  }, [lang]);

  const t = (path) => {
    const value = path.split(".").reduce((obj, key) => (obj != null ? obj[key] : undefined), translations[lang]);
    return value !== undefined ? value : path;
  };

  return <LanguageContext.Provider value={{ lang, setLang, t }}>{children}</LanguageContext.Provider>;
};
